import script from "./WeightAndUnits.vue?vue&type=script&setup=true&lang=js"
export * from "./WeightAndUnits.vue?vue&type=script&setup=true&lang=js"

import "./WeightAndUnits.vue?vue&type=style&index=0&id=ae564282&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae564282"]])

export default __exports__